export type RangeStrategy =
  | 'auto'
  | 'bump'
  | 'future'
  | 'pin'
  | 'replace'
  | 'update-lockfile'
  | 'widen';
